<template>
  <video
    preload="auto"
    poster="/images/passport-stamp-video-poster.jpg"
    :data-title="$tt('brand.name')"
    :data-description="$tt('page.hero_video')"
    :aria-label="$tt('page.hero_video')"
    autoplay muted loop playsinline
  >
    <source src="/videos/hero-video.mp4" type="video/mp4" />
  </video>
</template>